import React from "react";
import { Input, Form, InputNumber } from "antd";
import PropTypes from "prop-types";

import {
  CONTACT_NUMBER_REGEX,
  EMAIL_ADDRESS_REGEX,
  PRICE_REGEX,
} from "utils/constants";

import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import FormLabel from "components/FormLabel/FormLabel";
import Locale from "react-intl-universal";

const FormItem = Form.Item;
const { TextArea } = Input;

const INPUT_TYPE_CONTACT_NUMBER = "contactNumber";
const INPUT_TYPE_DEFAULT = "default";
const INPUT_TYPE_EMAIL = "email";
const INPUT_TYPE_FINANCIAL = "financial";
const INPUT_TYPE_TEXTAREA = "textArea";
const INPUT_TYPE_PASSWORD = "password";

const FormInput = ({
  disabled,
  extraProps,
  label,
  name,
  onFocus,
  placeholder,
  requiredErrorMessage,
  suffix,
  type,
  mandatory,
}) => {
  const localExtraProps = {
    ...extraProps,
    type: type === INPUT_TYPE_FINANCIAL ? "number" : extraProps.type,
  };

  const generatePropsForRules = () => {
    const rules = [];
    if (requiredErrorMessage && typeof requiredErrorMessage === "string") {
      rules.push({
        required: mandatory,
        message: requiredErrorMessage,
      });
    }
    if (type === INPUT_TYPE_FINANCIAL) {
      rules.push({
        pattern: PRICE_REGEX,
        message: `${label} ${Locale.get(
          "addNewAdvisee.financialInfo.errMsgTotalIncome"
        )}`,
      });
    }
    if (type === INPUT_TYPE_CONTACT_NUMBER) {
      rules.push({
        pattern: CONTACT_NUMBER_REGEX,
        message: `${label} must be a valid contact number.`,
      });
    }
    if (type === INPUT_TYPE_EMAIL) {
      rules.push({
        pattern: EMAIL_ADDRESS_REGEX,
        message: `${label} must be a valid email address.`,
      });
    }
    return rules;
  };

  return (
    <>
      {label && <FormLabel>{label}</FormLabel>}
      <FormItem
        rules={generatePropsForRules()}
        name={name}
        onFocus={() => onFocus(name)}
        onBlur={() => onFocus("")}
      >
        {type === INPUT_TYPE_TEXTAREA ? (
          <TextArea
            rows={4}
            disabled={disabled}
            placeholder={placeholder}
            {...localExtraProps}
          />
        ) : type === INPUT_TYPE_FINANCIAL ? (
          <InputNumber
            disabled={disabled}
            placeholder={placeholder}
            // {...localExtraProps}
            style={{ width: "100%" }}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value.replace(/(,*)/g, "")}
          />
        ) : type === INPUT_TYPE_PASSWORD ? (
          <Input.Password
            disabled={disabled}
            placeholder={placeholder}
            suffix={suffix}
            {...localExtraProps}
          />
        ) : (
          <Input
            disabled={disabled}
            placeholder={placeholder}
            suffix={suffix}
            {...localExtraProps}
          />
        )}
      </FormItem>
    </>
  );
};

FormInput.propTypes = {
  extraProps: PropTypes.object,
  onFocus: PropTypes.func,
  mandatory: PropTypes.bool,
  type: PropTypes.oneOf([
    INPUT_TYPE_DEFAULT,
    INPUT_TYPE_FINANCIAL,
    INPUT_TYPE_CONTACT_NUMBER,
    INPUT_TYPE_EMAIL,
    INPUT_TYPE_TEXTAREA,
  ]),
};

FormInput.defaultProps = {
  mandatory: true,
  extraProps: {},
  onFocus: () => {},
  type: INPUT_TYPE_DEFAULT,
};

export default FormInput;
